/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodLookLeft = createReactComponent("mood-look-left", "IconMoodLookLeft", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 9h.01", key: "svg-1" }],
  ["path", { d: "M4 15h4", key: "svg-2" }]
]);

export { IconMoodLookLeft as default };
//# sourceMappingURL=IconMoodLookLeft.js.map
